<fin-cms-global-disruption-banner></fin-cms-global-disruption-banner>
<fin-header></fin-header>
<fin-login-widget #loginWidget [context]="LoginWidgetContext.BOOKING"></fin-login-widget>
<fin-timetable></fin-timetable>
<fin-footer></fin-footer>
